import Icon from 'jitsi/base/icons/components/Icon';
import { IconClose } from 'jitsi/base/icons/svg';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { TailSpin } from 'react-loader-spinner';
const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'relative',
        marginTop: theme.spacing(2),
    },
    slideAction: {
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 2,
        backgroundColor: theme.palette.iisightGray700,
        boxShadow: '0 0 0 3px white',
        borderRadius: '50%',
        transform: 'translate(25%, -25%)',
    },
    loaderContainer: {
        width: 20,
        aspectRatio: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    removeButton: {
        width: 20,
        aspectRatio: '1',
        border: 'none',
        background: 'none',
        padding: 0,
    },
}));
export const Slide = ({ onRemove, children, uploading }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.slideAction }, uploading ? (React.createElement("div", { className: classes.loaderContainer },
            React.createElement(TailSpin, { color: 'white', height: 14, width: 14, strokeWidth: 3 }))) : (React.createElement("button", { className: classes.removeButton, onClick: onRemove },
            React.createElement(Icon, { src: IconClose, size: 14 })))),
        children));
};
